// @flow
import { TRANSITION_ENTER_DELAY, TRANSITION_ENTER_DURATION, TRANSITION_EXIT_DURATION } from './constants';

import CSSTransition from 'react-transition-group/CSSTransition';
import styled from 'styled-components';

const easeOutQuart = 'cubic-bezier(0.165, 0.84, 0.44, 1)';

export const StyledCSSTransition = styled(CSSTransition)`
    position: relative;
    width: 100%;

    &.fade-enter {
        left: 0;
        opacity: 0;
        top: 0;
        transform: translateY(5em);
        z-index: 100;
    }
    &.fade-enter.fade-enter-active {
        opacity: 1;
        transform: translateY(0);
        transition: opacity ${TRANSITION_ENTER_DURATION}ms ${TRANSITION_ENTER_DELAY}ms ${easeOutQuart},
            transform ${TRANSITION_ENTER_DURATION}ms ${TRANSITION_ENTER_DELAY}ms ${easeOutQuart};
    }

    &.fade-exit {
        opacity: 1;
        transform: scale(1);
        z-index: 1;
    }
    &.fade-exit.fade-exit-active {
        opacity: 0;
        transform: scale(0.8);
        transition: opacity ${TRANSITION_EXIT_DURATION}ms ${easeOutQuart},
            transform ${TRANSITION_EXIT_DURATION}ms ${easeOutQuart};
    }
`;



// WEBPACK FOOTER //
// ./src/components/routing/page-transition/styles.js